export default "__VITE_ASSET__$KfIuCeG__"